import React from 'react';

interface StatsCardProps {
    totalPickupPoints?: number;
    activePickupPoints?: number;
    totalRecyclers?: number;
    activeRecyclers?: number;
}

export default function StatsCard({
    totalPickupPoints = 0,
    activePickupPoints = 0,
    totalRecyclers = 0,
    activeRecyclers = 0
}: StatsCardProps) {

    const supplyPartnerPercentage = totalPickupPoints > 0
        ? (activePickupPoints / totalPickupPoints) * 100
        : 0;

    const recyclerPercentage = totalRecyclers > 0
        ? (activeRecyclers / totalRecyclers) * 100
        : 0;

    return (
        <div className="bg-white-100 flex gap-6">
            {/* SUPPLY PARTNER CARD */}
            <div className="flex-1 rounded-2xl overflow-hidden" style={{ backgroundColor: '#f4b7f9' }}>
                {/* Top Section */}
                <div
                    className="relative"
                    style={{
                        backgroundColor: '#bfd7ed',
                        padding: '20px 24px'
                    }}
                >
                    {/* Icon */}
                    <div style={{ marginBottom: '16px' }} className="flex justify-start">
                        <img
                            src="/icons8-test-account-60.png"
                            alt="Account"
                            style={{ width: '48px', height: '48px' }}
                        />
                    </div>

                    {/* Main Stats */}
                    <div className="flex items-center gap-4" style={{ marginBottom: '14px' }}>
                        <span className="text-6xl font-bold text-black leading-none">
                            {totalPickupPoints}
                        </span>
                        <div className="flex flex-col gap-0">
                            <span className="text-base font-semibold text-black">Supply</span>
                            <span className="text-base font-semibold text-black">Partners</span>
                        </div>
                    </div>

                    <div style={{ marginTop: '14px' }}>
                        <div className="flex justify-between items-center" style={{ marginBottom: '8px' }}>
                            <span className="text-sm font-bold text-black">% Active</span>
                            <span className="text-sm font-bold text-black">
                                {supplyPartnerPercentage.toFixed(1)}%
                            </span>
                        </div>
                        <div style={{
                            height: '16px',
                            backgroundColor: '#ffffff',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            border: '2px solid #000000',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
                        }}>
                            <div style={{
                                height: '100%',
                                width: `${Math.min(supplyPartnerPercentage, 100)}%`,
                                backgroundColor: '#60a3d9',
                                borderRadius: '18px',
                                transition: 'width 0.3s ease'
                            }} />
                        </div>
                    </div>
                </div>

                {/* Bottom Section */}
                <div
                    style={{
                        backgroundColor: '#60a3d9',
                        padding: '14px 24px'
                    }}
                >
                    <div className="flex flex-col gap-1">
                        <span className="text-5xl font-bold text-black leading-none">
                            {activePickupPoints}
                        </span>
                        <span className="text-sm font-semibold text-gray-900">Active Supply Partners</span>
                    </div>
                </div>
            </div>

            {/* RECYCLERS CARD */}
            <div className="flex-1 rounded-2xl overflow-hidden" style={{ backgroundColor: '#4f45f5' }}>
                {/* Top Section */}
                <div
                    className="relative"
                    style={{
                        backgroundColor: '#0074B7',
                        padding: '20px 24px'
                    }}
                >
                    {/* Icon */}
                    <div style={{ marginBottom: '16px' }} className="flex justify-start">
                        <img
                            src="/icons8-weight-kg-50.png"
                            alt="Weight"
                            style={{ width: '48px', height: '48px' }}
                        />
                    </div>

                    {/* Main Stats */}
                    <div className="flex items-center gap-4" style={{ marginBottom: '14px' }}>
                        <span className="text-6xl font-bold text-white leading-none">
                            {totalRecyclers}
                        </span>
                        <div className="flex flex-col gap-0">
                            <span className="text-base font-semibold text-white">Recyclers</span>
                        </div>
                    </div>

                    <div style={{ marginTop: '14px' }}>
                        <div className="flex justify-between items-center" style={{ marginBottom: '8px' }}>
                            <span className="text-sm font-bold text-white">% Active</span>
                            <span className="text-sm font-bold text-white">
                                {recyclerPercentage.toFixed(1)}%
                            </span>
                        </div>
                        <div style={{
                            height: '16px',
                            backgroundColor: '#ffffff',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            border: '2px solid #000000',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
                        }}>
                            <div style={{
                                height: '100%',
                                width: `${Math.min(recyclerPercentage, 100)}%`,
                                backgroundColor: '#003B73',
                                borderRadius: '18px',
                                transition: 'width 0.3s ease'
                            }} />
                        </div>
                    </div>
                </div>

                {/* Bottom Section */}
                <div
                    style={{
                        backgroundColor: '#003B73',
                        padding: '14px 24px'
                    }}
                >
                    <div className="flex flex-col gap-1">
                        <span className="text-5xl font-bold text-white leading-none">
                            {activeRecyclers}
                        </span>
                        <span className="text-sm font-semibold text-gray-100">Active Recyclers</span>
                    </div>
                </div>
            </div>
        </div>
    );
}